/**
 * Kept free of other imports so the user store can clear the draft on
 * sign-out without pulling in the Soul Map profile helpers.
 */
export const SOULMAP_PROFILE_DRAFT_KEY = 'soulmap-profile-draft';

/** Called on sign-out and when a new Soul Map sign-in starts. */
export function clearSoulMapProfileDraft(): void {
  try {
    sessionStorage.removeItem(SOULMAP_PROFILE_DRAFT_KEY);
  } catch {
    // Storage unavailable: nothing to clear.
  }
}
